import React from 'react';
import PropTypes from 'prop-types'
import Img from 'gatsby-image'
import parse from 'html-react-parser'
import {Container, Row, Col} from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import Text from '../../../components/ui/text'
import Button from '../../../components/ui/button'
import Image from '../../../components/image2'
import {HeroWrapper, HeroTextBox, ImageBoxWrap, ImageBoxOne, ImageBoxTwo} from './hero-area.style'
import { graphql, useStaticQuery } from "gatsby"

const HeroArea = ({title, subtitle, image, description, subtitleStyle, titleStyle, btnStyle, product, setFormActive, disableButton}) => {

    const heroDataQuery = useStaticQuery(graphql `
        query heroQueryData5 {
            infotechnoJson(id: {eq: "infotechno-hero-content"}) {
                image2 {
                    childImageSharp {
                        fluid(maxWidth: 706, maxHeight: 743, quality: 100) {
                            ...GatsbyImageSharpFluid_tracedSVG
                            presentationWidth
                            presentationHeight
                        }
                    }
                }
            }
            site: site {
                siteMetadata {
                    contact {
                        phone
                    }
                }
            }
        }
    `);

    return (
        <HeroWrapper>
            <Container fluid>
                <Row alignitems="center" style={{flexWrap:'wrap-reverse'}}>
                    <Col md={6}>
                        <HeroTextBox>
                            <Heading {...subtitleStyle}>{subtitle}</Heading>
                            <Heading {...titleStyle}>{parse(title)}</Heading>
                            <Text className="textLarger">{description}</Text>
                            {!disableButton && <Button {...btnStyle} onClick={() => {setFormActive(true)}}>Få tilbud på {product.toLowerCase()} &raquo;</Button>}
                            {heroDataQuery.site.siteMetadata.contact.phone && heroDataQuery.site.siteMetadata.contact.phone.length > 0 &&
                            <>
                                &nbsp;&nbsp;
                                <Button to={"tel:"+heroDataQuery.site.siteMetadata.contact.phone} {...btnStyle} style={{background: 'white', border: '2px solid #086AD8', color: '#086AD8'}}>Ring</Button>
                                {/*<Button as={Link} to={"/hva-er-en-garantiforsikring"} {...btnStyle} style={{background: 'white', border: '2px solid #086AD8', color: '#086AD8'}}>Les mer om garantiforsikringer</Button>*/}
                            </>
                            }
                            <br/>
                            <br/>
                        </HeroTextBox>
                    </Col>
                    <Col md={6}>
                        <ImageBoxWrap>
                            {image && (
                                <ImageBoxTwo>
                                    {/*<Image
                                        fluid={{
                                            ...image.fluid,
                                            sizes: "(max-width: 1200px) calc(100vw - 40px), 1200px",
                                        }}
                                        align="left" alt={title}/>*/}
                                    <Img
                                        fluid={image.fluid}
                                        objectFit="cover"
                                        objectPosition="50% 50%"
                                        alt={title}
                                        style={{overflow:'hidden',maxWidth:'560px',marginBottom:'30px'}}
                                    />
                                </ImageBoxTwo>
                            )}
                        </ImageBoxWrap>
                    </Col>
                </Row>
            </Container>
        </HeroWrapper>
    )
}

HeroArea.propTypes = {
    subtitleStyle: PropTypes.object,
    titleStyle: PropTypes.object,
    btnStyle: PropTypes.object,
    disableButton: PropTypes.bool
}

HeroArea.defaultProps = {
    subtitleStyle: {
        as: 'h6',
        color: 'primary',
        fontweight: 500,
        mb: '20px'
    },
    titleStyle: {
        as: 'h1',
        mb: '15px',
        fontweight: 500
    },
    btnStyle: {
        hover: '2',
        mt: '15px'
    },
    disableButton: false
}

export default HeroArea;
